var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataElementConsume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41177 28.1582C5.35593 28.1582 4.5 29.0141 4.5 30.07V34.8917C4.50416 39.0916 7.90834 42.4953 12.1083 42.4995H36.6736C40.8736 42.4953 44.2773 39.0911 44.2814 34.8912V30.07C44.2814 29.0141 43.4255 28.1582 42.3697 28.1582C41.3138 28.1582 40.4579 29.0141 40.4579 30.07V34.8904C40.4544 36.9795 38.7613 38.6722 36.6723 38.6759L12.1085 38.6759C10.0197 38.6722 8.32721 36.9797 8.32355 34.8908V30.07C8.32355 29.0141 7.46762 28.1582 6.41177 28.1582Z",
    fill: "#A614B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3907 5.49983C23.3349 5.49983 22.4789 6.35576 22.4789 7.4116L22.4789 27.1693L17.6854 22.3758C16.9385 21.6289 15.7275 21.6289 14.9806 22.3758C14.2337 23.1227 14.2337 24.3337 14.9806 25.0806L23.0348 33.1347L23.0373 33.1372C23.1279 33.2265 23.2271 33.3066 23.3336 33.3762L23.3522 33.3883L23.4777 33.4554L23.6692 33.5512L23.8517 33.606L23.8543 33.6067L23.9959 33.6484L24.0179 33.6528C24.264 33.7017 24.5174 33.7017 24.7635 33.6528L24.7855 33.6484L24.9271 33.6067L24.9297 33.606L25.1122 33.5512L25.2921 33.4615L25.4292 33.3883L25.4478 33.3762C25.5543 33.3066 25.6536 33.2265 25.7441 33.1372L25.7466 33.1347L33.7959 25.0855L33.8106 25.0678C34.4395 24.3111 34.3913 23.2006 33.6993 22.5012C33.0073 21.8018 31.8975 21.7418 31.1341 22.3626L31.1142 22.3788L26.3025 27.1905L26.3025 7.4116C26.3025 6.35576 25.4466 5.49983 24.3907 5.49983Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataElementConsume);
export default __webpack_public_path__ + "static/media/data-element-consume.fd458b458e81ea6df271d4a5bfda0724.svg";
export { ForwardRef as ReactComponent };